import './index.css';

function Error404() {
  return (
    <div id="Error404">
      <h1 className="Error404">Error 404: Page Not Found</h1>
      <p className="Error404">This page does not exist, sorry!</p>
    </div>
  );
}

export default Error404;
